module.exports = __webpack_public_path__ + "img/health.6d47e4c.svg";